module.exports = __webpack_public_path__ + "img/img10.871b5099.png";